import { render } from "./CommentRespond.vue?vue&type=template&id=07f81b8d&scoped=true"
import script from "./CommentRespond.vue?vue&type=script&lang=js"
export * from "./CommentRespond.vue?vue&type=script&lang=js"

import "./CommentRespond.vue?vue&type=style&index=0&id=07f81b8d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f81b8d"]])

export default __exports__